function loadScript(url)
{
    // Adding the script tag to the head as suggested before
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    // Fire the loading
    head.appendChild(script);
}

function playVideo(){
if($( window ).width() < 746){
    $('#head .videoBg').addClass('nonMobileBg')
                       .css('height','')
                       .attr('data-vide-bg','')
                       .attr('data-vide-options','')
                       .html('');
}else{
    console.log('loading');
    loadScript('https://www.paroplavba.cz/js/libs/jquery.vide.js');
}
}

function colBlank(){
    $('#colsBlank').css('height',($('#cols .relative').height()-114));
    $('#colsBlank').css('height',($('.cols .relative').height()-114));
}

$(document).ready(function () {
    setTimeout(playVideo, 500);


    var $lg = $('.reference').lightGallery({
        selector: 'a'
    });
    $lg.on('onBeforeOpen.lg',function(event){
        $(this).find('.img').find('img:not(.lazy)').each(function() {
            $(this).attr('src',$(this).attr('data-src'));
        });
    });

    $.fn.BeerSlider = function ( options ) {
        options = options || {};
        return this.each(function() {
          new BeerSlider(this, options);
        });
      };
    $('.beer-slider').BeerSlider({start: 50});

    //plyr.setup(document.querySelectorAll('.js-video-player'), {volume:5});
    var owl = $('.owl-carousel2');

    owl.owlCarousel({
        loop: true,
        margin: 10,
        items: 1,
        nav: true,
        animateOut: 'fadeOut',
        navText:['<img src="https://www.prague-boats.cz/img/arrow-left.svg">','<img src="https://www.prague-boats.cz/img/arrow-right.svg">'],
        autoplay:true,
        autoplayTimeout:7000
    });

    var owlMapInteractive = $('.interactive-map');

    owlMapInteractive.owlCarousel({
       navigation: true, // Show next and prev buttons
       slideSpeed: 300,
       margin: 0,
       items:1,
       nav: true,
       loop: true,
       paginationSpeed: 400,
      // animateOut: 'fadeOut',
       navText:['<i class="fa fa-arrow-right"></i>','<i class="fa fa-arrow-right"></i>'],
       singleItem: true,
       afterAction: function(current) {
           current.find('video').get(0).play();
       }
    });

    setTimeout(colBlank, 1000);

    $('.menu-foods .close-food').click(function() {
        if($('body').hasClass('locked')){
            $('body').removeClass('locked');
            $('.menu-foods').removeClass('active');
        }else{
            $('body').addClass('locked');
            $('.menu-foods').addClass('active');
        }
    });

    $(function (){
         $("input,select,textarea").not("[type=submit]").jqBootstrapValidation();
    });

    $('.lazy').lazy();

    $( "#nav a.mobileControl" ).click(function() {
        val = $('#mobile-nav').css('display');
        $('#mobile-nav').html("<strong>Navigace</strong><ul>"+$('#nav ul').html()+"</ul>");
        if(val == "none"){
           $(this).addClass('active');
           $('#nav a.mobileControl i').removeClass('fa-bars');
           $('#nav a.mobileControl i').addClass('fa-times');
           $('.cover-border').addClass('active');
           $('#mobile-nav').css('display','block');
        }else{
           $(this).removeClass('active');
           $('#nav a.mobileControl i').addClass('fa-bars');
           $('#nav a.mobileControl i').removeClass('fa-times');
           $('.cover-border').removeClass('active');
           $('#mobile-nav').css('display','none');
        }
    });

    $( "#data .cruises-list a" ).click(function() {
        $('#data .cruises-list a').removeClass('active');
        $(this).addClass('active');
        $('.cruises-list-ul').removeClass('active');
        $('#'+$(this).attr('data-target')).addClass('active');
    });

    $( window ).resize(function() {
        width = $( window ).width();
        if(width > 984){
            $('#nav ul').css('display','block');
        }else{
            $('#nav ul').css('display','none');
            $('#nav').removeClass('active');
            $('#nav a.mobileControl i').addClass('fa-bars');
           $('#nav a.mobileControl i').removeClass('fa-times');
        }
        $('#colsBlank').css('height',($('.cols .relative').height()-114));

        if($('body').hasClass("subPage")){
            $('#head.subPage span.bg-img').css('height',($('#head.subPage').height()+100));
        }
    });

    if($('body').hasClass("subPage")){
        $('#head.subPage span.bg-img').css('height',($('#head.subPage').height()+100));
    }


    if($('body').hasClass("subPage")){
        plyr.setup({volume:5});
    }


    $( "#data .show-menu-modal" ).click(function() {
        if($('body').hasClass('locked')){
            $('body').removeClass('locked');
            $('.menu-foods').removeClass('active');
        }else{
            $('body').addClass('locked');
            $('.menu-foods').addClass('active');
        }
    });

    $( "#data .show-menu" ).click(function() {
        val = $('#data .menu-food').css('display');
        if(val == "none"){
            str = $(this).attr('data-off');
            $(this).html('<span>'+str+'</span>');
            $('#data .menu-food').css('display','block');
        }else{
            str = $(this).attr('data-on');
            $(this).html('<span>'+str+'</span>');
            $('#data .menu-food').css('display','none');
        }
    });

    // ONLY NUMERIC CHARACTERS
	$('.input-numeric').keyup(function (e) {
		this.value = this.value.replace(/[^0-9]+/g, '');
	});

	$('.input-numeric-with-arrows').inputIncDec();

    $(document).on("click",'.giftbox .radio',function(){
        $('.giftbox .radio input[type="radio"]').prop("checked", false);
        $(this).find('input[type="radio"]').prop("checked", true);
        $('.voucherview .voucher').removeClass('active');
        $('.voucherview #voucher-'+$(this).find('input[type="radio"]').attr('data-voucher')).addClass('active');
    });

    $(document).on("click",'.chosebox .radio',function(){
        $('.chosebox .radio input[type="radio"]').prop("checked", false);
        $(this).find('input[type="radio"]').prop("checked", true);
    });

    $(document).on("click",'.companyOrder',function(){
        val = $(this).find('input[type="checkbox"]').prop("checked");
        if(val == true){
            $(this).find('input[type="checkbox"]').prop("checked",false);
            $('.hidden-checkbox').removeClass('active');
        }else{
            $(this).find('input[type="checkbox"]').prop("checked",true);
            $('.hidden-checkbox').addClass('active');
        }
    });

    $(function() {
      $('select').selectric();
    });

    $('.js-gift-message').keyup(function() {
        var input = this,
            target = $('.voucherview .voucher .ded');

        target.html($(this).val());

        if ($(this).val().length === 0) {
            target.html('…Zde může být Vaše věnování…');
        }
    }).change(function() {
        var input = this,
            target = $('.voucherview .voucher .ded');

        target.html($(this).val());

        if ($(this).val().length === 0) {
            target.html('…Zde může být Vaše věnování…');
        }
    });


    $('.input-group button.inc').click(function(e){
        var input = $(this).parents('.input-group').find('input');

        if (input.val() !== '') {
            input.val(parseFloat(input.val()) + 1);
        } else {
            input.val(1);
        }
        input.triggerHandler('change');

        reCalculatePrice();
    });

    $('.input-group button.dec').click(function(e){
        var input = $(this).parents('.input-group').find('input');

        if (input.val() > 0) {
            input.val(parseFloat(input.val()) - 1);
            input.trigger('change');
        }

        reCalculatePrice();
    });

    /* Eshop */
    /*
	global.totalPriceHolder = $('#total-price');
	if (global.totalPriceHolder.exists) {
		global.totalPriceHolder.data('total-price-original', global.totalPriceHolder.text());
		// DYNAMIC PRICE COMPUTING
		$('[data-unit-price]').totalPrice();
	}
    */

    // MASTER SLAVE COMPONENT
	$('[data-master-for]').masterSlave();

    $('.photos a').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        }
    });

    $('.btn-iframe').magnificPopup({
        type: 'iframe',
        gallery: {
            enabled: false
        }
    });

    $('.show-modals').click(function(e){
        $('.modals').removeClass('active');
        $('.modals#'+$(this).attr('data-target')).addClass('active');
    });
    $('.close-modals').click(function(e){
        $(this).closest('.modals').removeClass('active');
    });
});


function reCalculatePrice(){
    var price = 0;

    $( ".input-group" ).each(function( i ) {
        price = price + parseFloat($(this).find('input[type="text"]').attr('data-unit-price'))*parseFloat($(this).find('input[type="text"]').val());
    });

    $('#total-price').html(price);

}


//= Inputs with arrow dec/inc

$.fn.inputIncDec = function () {
	$(this).each(function () {
		var input = $(this),
			btnsTemplate = '<span class="input-group-btn">' +
								'<button type="button" class="btn btn-default inc">+</button>' +
								'<button type="button" class="btn btn-default dec">-</button>' +
							'</span>';
		input.wrap('<div class="input-group" />');
		input.parent().append(btnsTemplate);
		if (input.parent('.input-group').length) {
			var btnInc = input.parent().find('.inc'),
				btnDec = input.parent().find('.dec');
			if (btnInc.exists && btnDec.exists) {
				// incrementing
				btnInc.click(function () {
					if (input.val() !== '') {
						input.val(parseFloat(input.val()) + 1);
					} else {
						input.val(1);
					}
					input.triggerHandler('change');
				});
				// decrementing
				btnDec.click(function () {
					if (input.val() > 0) {
						input.val(parseFloat(input.val()) - 1);
						input.trigger('change');
					}
				});
			}
		}
	});
};

//= Total price computing

$.fn.totalPrice = function () {
	var inputs = $(this),
		totalPrice = 0;
	inputs.bind('keyup change', function (e) {
		totalPrice = 0;
		inputs.each(function () {
			var input = $(this),
				unitPrice = input.data('unit-price');
			if (!input.is(':radio') && !input.is(':checkbox')) { // handle textboxes
				if (!isNaN(parseFloat(input.val()))) {
					if (input.val() < 0) {
						input.val(0);
					}
				totalPrice += input.val() * unitPrice;
				}
			} else { // handle radio buttons and checkboxes
				if (input.is(':checked')) {
					totalPrice += input.data('unit-price');
				}
			}
		});
		totalPrice = parseFloat(totalPrice) + parseFloat(global.totalPriceHolder.data('total-price-original'));
		global.totalPriceHolder.text(Math.round(totalPrice * 100) / 100); // keep the original price when page is loaded
	}).each(function () {
		if (jQuery(this).is(':checked')) {
			totalPrice += jQuery(this).data('unit-price');
		}
	});
	totalPrice = parseFloat(totalPrice) + parseFloat(global.totalPriceHolder.data('total-price-original'));
	global.totalPriceHolder.text(Math.round(totalPrice * 100) / 100); // keep the original price when page is loaded
};



//= Master & slave component

$.fn.masterSlave = function () {
	$(this).each(function () {
		var master = $(this),
		  slaves = master.data('master-for').split(',');

		function processState(component, enabled) {
		  component.each(function () {
			var cmp = $(this)
			if (!cmp.is('input') && !cmp.is('select') && !cmp.is('textarea')) { // for non "checkable" component
			  if (enabled) {
				cmp.slideDown(200).find('input:text, textarea').prop('required', true);
			  } else {
				cmp.slideUp(200).find('input:text, textarea').removeAttr('required');
			  }
			} else { // for form elements
			  if (enabled) {
				cmp.removeAttr('disabled');
				cmp.prev('span').removeClass('like-' + cmp.attr('type') + '-disabled'); // handle custom radios/checkboxes elements
				cmp.closest('.' + cmp.attr('type')).removeClass('disabled');
			  } else {
				cmp.attr('disabled', 'disabled');
				cmp.prev('span').addClass('like-' + cmp.attr('type') + '-disabled'); // handle custom radios/checkboxes elements
				cmp.closest('.' + cmp.attr('type')).addClass('disabled');
			  }
			}
		  });
		}

		function getSlavesByMaster(master) {
		  if (master.data('master-for') !== undefined) { // filter non-master components
			var slavesIds = master.data('master-for').split(','),
			  slaves = Array();
			for (var k = 0; k < slavesIds.length; k++) {
			  var slave = $('#' + slavesIds[k]);
			  if (slave.length) {
				slaves.push(slave.get(0));
			  }
			}
			return jQuery(slaves);
		  }
		}

		function disableAllByMaster(master) {
		  var slaves = getSlavesByMaster(master),
			masterSiblings = $('input[name="' + master.attr('name') + '"]'); // get all master siblings
		  masterSiblings.each(function () {
			processState(getSlavesByMaster($(this)), false); // disable/hide all slaves defined by master all masters
		  });
		}

		master.change(function () {
		  disableAllByMaster(master);

		  if (master.is(':checked')) {
			processState(getSlavesByMaster(master), Boolean(master.data('slave-enabled')));
		  } else {
			var masterSiblings = $('input[name="' + master.attr('name') + '"]'),
			  masterIsAlreadyChecked = false;

			// check if one of master siblings is checked, if yes do not process state controled by the other masters
			masterSiblings.each(function () {
			  if ($(this).is(':checked')) {
				masterIsAlreadyChecked = true;
				return;
			  }
			});
		  }
		});

		// after page load
		if (master.is(':checked')) {
		  disableAllByMaster(master);
		  processState(getSlavesByMaster(master), Boolean(master.data('slave-enabled')));
		}

		var masterSiblings = $('input[name="' + master.attr('name') + '"]'),
		  masterIsAlreadyChecked = false;

		// check if one of master siblings is checked, if yes do not process state controled by the other masters
		masterSiblings.each(function () {
		  if ($(this).is(':checked')) {
			masterIsAlreadyChecked = true;
			return;
		  }
		});

		if (!masterIsAlreadyChecked) {
		  disableAllByMaster(master);
		}

	});
};

// detect IOS, Android
function goToUri(uri, href) {
	var start, end, elapsed;

	// start a timer
	// start = new Date().getTime();

	// attempt to redirect to the uri:scheme
	// the lovely thing about javascript is that it's single threadded.
	// if this WORKS, it'll stutter for a split second, causing the timer to be off
	// document.location = uri;

	// end timer
	// end = new Date().getTime();

	// elapsed = (end - start);

	// if there's no elapsed time, then the scheme didn't fire, and we head to the url.
	// if (elapsed < 1 && uri.indexOf('http') != 0 && href !== undefined) {
	// 	document.location = href;
	// }

             setTimeout(function () { window.location = href; }, 50);
             window.location = uri;
}

function goToUriBad(uri, href) {
    if(!window.open(uri) && href !== undefined) {
        window.location = href;
    }
}

function goToFB(uri, fbUri) {
	start = new Date().getTime();

	// attempt to redirect to the uri:scheme
	// the lovely thing about javascript is that it's single threadded.
	// if this WORKS, it'll stutter for a split second, causing the timer to be off
	document.location = uri;

	// end timer
	end = new Date().getTime();

	elapsed = (end - start);

	if (elapsed <  1 ) {
		try {
			FB.ui({
				method: 'feed',
				link: fbUri,
				caption: 'PĹ™eÄŤtÄ›te si',
			}, function(response){});
		} catch(e) {
			console.log('fb share error');
		}

	}
}

$(document).ready(function() {
    var IS_IPAD = navigator.userAgent.match(/iPad/i) != null,
        IS_IPHONE = !IS_IPAD && ((navigator.userAgent.match(/iPhone/i) != null) || (navigator.userAgent.match(/iPod/i) != null)),
        IS_IOS = IS_IPAD || IS_IPHONE,
        IS_ANDROID = !IS_IOS && navigator.userAgent.match(/android/i) != null,
        IS_MOBILE = IS_IOS || IS_ANDROID;

    if (IS_IOS) {
        $('a.intent').on('click', function (event) {
            goToUri($(this).data('uri-scheme'), $(this).data('store-ios'));
            event.preventDefault();
            return false;
        });
    } else if (IS_ANDROID ) {
        $('a.intent').on('click', function (event) {
            goToUri($(this).data('uri-scheme'), $(this).data('store-android'));
            event.preventDefault();
            return false;
        });
    } else {
        $('a.intent').on('click', function (event) {
            goToUri($(this).data('uri-scheme'));
            event.preventDefault();
            return false;
        });

    }

    $('a.fb').on('click',function(event ){
        goToFB($(this).data('uri-scheme'), $(this).data('uri-url'));
        event.preventDefault();
        return false;
    });



    $('a.twitt').on('click', function(event) {
        goToUri($(this).data('uri-scheme'), $(this).data('fallback-uri'));
        event.preventDefault();
        return false;
    });

    $('.share.facebook').click(function (e) {
        dataLayer.push({
            'event': 'ga.event',
            'eCategory': 'Sdileci_tlacitka',
            'eAction': 'Sdileci_tlacitka',
            'eLabel': 'Facebook',
            'eValue': 1
        });
    });

    $('.share.twitter').click(function (e) {
        dataLayer.push({
            'event': 'ga.event',
            'eCategory': 'Sdileci_tlacitka',
            'eAction': 'Sdileci_tlacitka',
            'eLabel': 'Twitter',
            'eValue': 1
        });
    });

    $('.share.messenger').click(function (e) {
        dataLayer.push({
            'event': 'ga.event',
            'eCategory': 'Sdileci_tlacitka',
            'eAction': 'Sdileci_tlacitka',
            'eLabel': 'Messenger',
            'eValue': 1
        });
    });

    $('.share.whatsapp').click(function (e) {
        dataLayer.push({
            'event': 'ga.event',
            'eCategory': 'Sdileci_tlacitka',
            'eAction': 'Sdileci_tlacitka',
            'eLabel': 'Whatsapp',
            'eValue': 1
        });
    });

    $('.share.e-mail').click(function (e) {
        dataLayer.push({
            'event': 'ga.event',
            'eCategory': 'Sdileci_tlacitka',
            'eAction': 'Sdileci_tlacitka',
            'eLabel': 'E-mail',
            'eValue': 1
        });
    });

});
